<template>
  <div class="check-offer-code">
    <a :href="url" id="some" target="_blank"></a>
    <app-loading :isFull="true" v-if="isLoading"/>
    <div class="row pt-3">
      <div class="col-8">
        <div class="group-form">
          <!-- v-validate="'required'" -->
          <input
            type="text"
            name="offerCode"
            :class="{active:offerCode != '' }"
            v-model="offerCode"
            @keyup.enter="chechkOfferCode"
          >
          <span class="bar"></span>
          <label>کد تخفیف دارید؟</label>
          <!-- <span v-if="errors.has('offerCode')" class="is-danger">فیلد نباید خالی باشد</span> -->
        </div>
      </div>
      <div class="col-3 p-0">
        <button
          class="mt-3 bttn-fill bttn bttn-warning font-12 p-2"
          @click="chechkOfferCode"
          v-ripple
        >
          <i class="flaticon-discount-1"></i>
          بررسی کد
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <span
          class="font-weight-bold font-16 d-inline-block mt-3 font-14"
          :class="{'dis-line':singelItem.course_price ||  singelItem.course_price === 0}"
        >
          مبلغ :
          {{price | currency}}
        </span>
      </div>
      <div class="col-12" v-if="singelItem.course_price || singelItem.course_price === 0">
        <span class="font-weight-bold font-16 d-inline-block mt-3 font-14">
          مبلغ نهایی :
          {{singelItem.course_price | currency}}
        </span>
      </div>
      <div class="col-sm-12">
        <button
          @click="prebill('melli')"
          class="align-items-center
          justify-content-center w-100 d-flex mb-1
           bttn-gradient bttn-primary
           mt-3"
          v-ripple
          title="خرید"
        >
          <i class="flaticon-list-2 ml-1"></i>
          <span class="font-16">خرید دوره</span>
        </button>
      </div>
      <!-- {'btn-danger pointer-null':isClicked} -->

    </div>
  </div>
</template>

<script>
  export default {
    name: "check-offer-code",
    props: {
      price: ""
    },
    data() {
      return {
        isLoading: false,
        // offerCode: "",
        url: { link: null },
        modal: false
      };
    },
    destroyed() {
      this.offerCode = "";
      // this.singelItem = {};
      this.$store.commit("basket/SET_DATA", { data: {}, id: "singleItem" });
    },
    computed: {
      offerCode: {
        get(value) {
          return this.$store.state.basket.offerCode;
        },
        set(value) {
          this.$store.commit("basket/SET_DATA", { data: value, id: "offerCode" });
        }
      },
      singelItem() {
        return this.$store.state.basket.singleItem;
      },
      priceOffer() {
        return this.$store.state.basket.priceOffer;
      }
    },
    methods: {
      openModal() {
        this.$store.commit("basket/SET_DATA", { data: true, id: "isPayment" });
      },
      async chechkOfferCode() {
        if (!this.isLogin) {
          this.$store.commit("auth/setRedirect", false);
          this.$store.commit("basket/SET_DATA", { data: false, id: "isPayment" });
          this.showModalLogin();
          return;
        }
        this.isLoading = true;
        let data = await this.$store.dispatch("basket/checkOfferCode", {
          code: this.offerCode,
          course_id: parseInt(this.$route.params.id)
        });
        this.isLoading = false;
      },
      prebill(gateway) {
        if (!this.isLogin) {
          this.$store.commit("auth/setRedirect", false);
          this.$store.commit("basket/SET_DATA", { data: false, id: "isPayment" });
          this.showModalLogin();
          return;
        }
        this.complateAction(gateway);
      },
      async complateAction() {
          if(this.offerCode){
            if(this.singelItem.course_price === 0 || this.singelItem.course_price === "0"){
              try {
                await this.$store.dispatch("basket/postPrebill", {
                  code:this.offerCode,
                  course : [this.$route.params.id],
                  gateway: 'sadad'
                });

              } catch (error) {
                this.$store.commit("notifications/warn", {
                  message: error.message,
                  title: " خطا " + error.err
                });
              }
            } else {
              this.$store.commit('basket/SET_DATA',{id:'isPayment',data:true})
            }
          } else {
            this.$store.commit('basket/SET_DATA',{id:'isPayment',data:true})
          }
      }
    }
  };
</script>

<style lang="less" scoped>
  @import (reference) "../../assets/css/variable.less";

  .dis-line {
    text-decoration: line-through;
    color: #686f7a;
    font-weight: 400;
    font-size: 13px;
    margin-right: 5px;
    text-decoration: line-through;
  }
  .group-form {
    textarea.active ~ label,
    textarea:focus ~ label,
    input.active ~ label,
    input:focus ~ label {
      visibility: hidden;
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/min-component/check-offer-code.vue